<app-shared-table
  [maxCount]="totalUsers"
  [items]="users"
  [isType]="'User'"
  [showButtons]="['edit', 'delete']"
  (itemEdit)="editUser($event)"
  (itemDelete)="deleteUser($event)"
  (loadPageData)="loadPageData($event)"
  >
</app-shared-table>

<div class="col-sm-12 col-md-6 col-lg-4">
  <ng-template #customContent let-c="close" let-d="dismiss">
    <div class="modal-header">
      <h4 class="modal-title">{{ submitType }} User</h4>
      <button
        type="button"
        class="btn-close"
        aria-label="Close"
        (click)="d('Cross click'); resetForm()"
      ></button>
    </div>
    <div class="modal-body">
      <form [formGroup]="formUsers">
        <div class="row">
          <div class="col-6">
            <mat-form-field class="example-full-width">
              <mat-label>Name</mat-label>
              <input matInput placeholder="Name" formControlName="name" />
            </mat-form-field>
          </div>
          <div class="col-6">
            <mat-form-field class="example-full-width">
              <mat-label>Email</mat-label>
              <input
                matInput
                placeholder="Email"
                formControlName="email"
                type="email"
                />
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            @if (submitType !== 'Edit') {
              <div class="col-6">
                <mat-form-field class="example-full-width">
                  <mat-label>Password</mat-label>
                  <input
                    matInput
                    placeholder="Password"
                    formControlName="password"
                    />
                    <mat-error>
                      Password must be atleast 8 characters long and contain a letter,
                      number and a special character
                    </mat-error>
                  </mat-form-field>
                </div>
              }
              <div class="col-6">
                <mat-form-field>
                  <mat-label>Role</mat-label>
                  <mat-select
                    formControlName="roles"
                    multiple="true"
                    [disabled]="roleCheck()"
                    >
                    @for (adminType of rolesFilter(); track adminType) {
                      <mat-option
                        [value]="adminType"
                        >
                        {{ adminType }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          </form>
        </div>

        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-raised btn-success"
            [disabled]="formUsers.invalid"
            (click)="c('Close click'); submitUser()"
            >
            {{ submitType }} User
          </button>

          <button
            type="button"
            class="btn btn-secondary btn-raised"
            (click)="c('Close click'); resetForm()"
            >
            Close
          </button>
        </div>
      </ng-template>

      <button
        id="openModal"
        class="btn btn-lg btn-outline-primary"
        (click)="addUser()"
        >
        Add User
      </button>
    </div>
